import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import AddMemberInvoiceComponent from './component'

export const MemberInvoiceAdd = combine({
  hooks: [
    withContext(
      'adminMemberInvoiceService',
      ServicesContext,
      ({ adminMemberInvoiceService }) => adminMemberInvoiceService
    ),

    withCallback(
      'onSubmit',
      ({ adminMemberInvoiceService }, { history, match }) =>
        async (invoice) => {
          const memberId = Number(match.params.memberId)
          await adminMemberInvoiceService.createMemberInvoice(memberId, invoice)
          toaster.info('Member invoice has been successfully created')
          history.push(admin.sponsors.invoices.view(memberId))
        },
      []
    ),
  ],
  transformProps: ({ match, onSubmit }) => {
    return {
      memberId: Number(match.params.memberId),
      onSubmit,
    }
  },
})(AddMemberInvoiceComponent)
